import List from 'semantic-ui-react/dist/commonjs/elements/List';
import '@purple/semantic-ui-purple-theme/components/list.css';

export default List;
